import React from 'react';
import Ratings from '../../components/AdminNext/Ratings';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };
  return {
    title: 'Ratings & reviews — Bas Recovery Admin',
    component: <HeadLessLayout><Ratings /></HeadLessLayout>
  };
}

export default action;
